"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Card = _interopRequireDefault(require("@material-ui/core/Card"));
var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _i18n = require("../../../../../Framework/i18n");
var _AnalyticsWrapper = _interopRequireDefault(require("../../../../Shared/Components/Analytics/AnalyticsWrapper"));
var _CallToAction = _interopRequireDefault(require("../../../../Shared/Components/CallToAction"));
var _customClassName = _interopRequireDefault(require("../../../../Utils/customClassName"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    card: {
      borderTop: '7px solid ' + theme.palette.primary.main,
      maxWidth: 650
    },
    cardUnboxed: _defineProperty({
      borderTop: 'none',
      boxShadow: 'none'
    }, theme.breakpoints.down('xs'), {
      borderRadius: 0,
      paddingTop: 4
    }),
    contentWrapper: _defineProperty({
      textAlign: 'center'
    }, theme.breakpoints.down('xs'), {
      '& div:first-child': {
        marginBottom: 16
      }
    }),
    addVisualButton: _defineProperty({
      textTransform: 'none',
      whiteSpace: 'nowrap',
      width: '90% !important',
      overflow: 'hidden',
      borderRadius: 4,
      border: '1px solid #C4C4C4',
      height: 40,
      '& input': {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        opacity: 0,
        cursor: 'pointer'
      },
      pointerEvents: 'all'
    }, theme.breakpoints.down('xs'), {
      height: 56,
      width: '100%',
      '& > span': {
        justifyContent: 'flex-start'
      }
    }),
    addVisualElementIconRoot: {
      paddingLeft: 5
    },
    addVisualContent: _defineProperty({
      padding: 15,
      '&:last-child': {
        paddingBottom: 15
      }
    }, theme.breakpoints.down('xs'), {
      padding: 0
    }),
    labelText: {
      minWidth: 120,
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  };
};
var AddVisualElement = /*#__PURE__*/function (_React$Component) {
  _inherits(AddVisualElement, _React$Component);
  var _super = _createSuper(AddVisualElement);
  function AddVisualElement() {
    _classCallCheck(this, AddVisualElement);
    return _super.apply(this, arguments);
  }
  _createClass(AddVisualElement, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        boxed = _this$props.boxed,
        width = _this$props.width,
        classes = _this$props.classes,
        onAddImageClick = _this$props.onAddImageClick,
        onAddTextClick = _this$props.onAddTextClick,
        onImageFileSelected = _this$props.onImageFileSelected,
        ButtonContainer = _this$props.components.ButtonContainer,
        renderAddImageLabel = _this$props.renderAddImageLabel,
        renderAddTextLabel = _this$props.renderAddTextLabel,
        hasLastEditedDesignArea = _this$props.hasLastEditedDesignArea,
        enableAddText = _this$props.enableAddText,
        enableAddImage = _this$props.enableAddImage;
      if (!enableAddText && !enableAddImage) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        lg: 12,
        md: 12,
        ref: function ref(_ref) {
          return _this.callToActionRef = _ref;
        }
      }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        className: (0, _clsx["default"])(boxed && width !== 'xs' ? classes.card : classes.cardUnboxed, (0, _customClassName["default"])('add-elements-box'))
      }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        classes: {
          root: classes.addVisualContent
        }
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        className: classes.contentWrapper
      }, enableAddImage && /*#__PURE__*/_react["default"].createElement(ButtonContainer, {
        item: true,
        xs: 12,
        sm: enableAddText ? 6 : 12
      }, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "add_image"
      }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "outlined",
        size: "large",
        classes: {
          root: classes.addVisualButton
        },
        onClick: onAddImageClick,
        ref: this.callToActionRef
      }, renderAddImageLabel(this.props), onImageFileSelected && /*#__PURE__*/_react["default"].createElement("input", {
        type: "file",
        onChange: onImageFileSelected
      })), !hasLastEditedDesignArea && /*#__PURE__*/_react["default"].createElement(_CallToAction["default"], {
        offsetDirection: "top",
        anchorRef: this.callToActionRef,
        offset: 20,
        label: (0, _i18n.t)('initialCallToAction.addElementNow'),
        className: (0, _customClassName["default"])('begin-here-designer')
      })))), enableAddText && /*#__PURE__*/_react["default"].createElement(ButtonContainer, {
        item: true,
        xs: 12,
        sm: enableAddImage ? 6 : 12
      }, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "add_text"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "outlined",
        size: "large",
        onClick: onAddTextClick,
        classes: {
          root: classes.addVisualButton
        }
      }, renderAddTextLabel(this.props)))))))));
    }
  }]);
  return AddVisualElement;
}(_react["default"].Component);
_defineProperty(AddVisualElement, "defaultProps", {
  boxed: false,
  classes: {},
  components: {
    ButtonContainer: _Grid["default"]
  },
  enableAddText: true,
  enableAddImage: true,
  renderAddImageLabel: function renderAddImageLabel(_ref2) {
    var classes = _ref2.classes;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      classes: {
        root: classes.addVisualElementIconRoot
      },
      style: {
        marginRight: 8
      }
    }, "image"), /*#__PURE__*/_react["default"].createElement("b", {
      className: classes.labelText
    }, (0, _i18n.t)('addVisualElement.image')));
  },
  renderAddTextLabel: function renderAddTextLabel(_ref3) {
    var classes = _ref3.classes;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      style: {
        marginRight: 8
      }
    }, "text_format"), /*#__PURE__*/_react["default"].createElement("b", {
      className: classes.labelText
    }, (0, _i18n.t)('addVisualElement.text')));
  }
});
var _default = exports["default"] = (0, _withWidth["default"])({
  initialWidth: 'lg'
})((0, _styles.withStyles)(styles, {
  name: 'AddVisualElement'
})(AddVisualElement));